// Copyright (c) 2023 Deere & Company

import DuplicatePinPlate from '@deere/cps-it.warranty-model-factory/lib/duplicate-pin-plate';
import t from 'tcomb';

const DuplicatePinPlateView = t.list(DuplicatePinPlate, 'DuplicatePinPlateView');

export const getDefaultState = () => new DuplicatePinPlateView([]);

export default DuplicatePinPlateView;



// WEBPACK FOOTER //
// ./src/tcsm/wip/state/duplicate-pin-plate.js